import axios from "axios";
import AppConfig from "../_appConfig";

const server = AppConfig.api_server;

export default {
  leaderboard: {
    all: (day) =>
      axios
        .get(server + `/leaderboard/all/?day=${day}`)
        .then((res) => res.data),
  }
};